<template>
	<li :class="classes">
		<span v-if="icon" class="InlineList-divider">
			<CloIcon :symbol="icon" size="sm" />
		</span>
		<slot />
	</li>
</template>

<script>
import CloIcon from '@/icons/CloIcon/CloIcon.vue';

export default {
	name: 'CloInlineListItem',
	components: {
		CloIcon,
	},
	data() {
		return {};
	},
	props: {
		/**
		 * Separate items with vertical line
		 */
		icon: {
			type: String,
			default: null,
		},
		/**
		 * Styles a list item active
		 */
		active: {
			type: Boolean,
			default: false,
		},
		/**
		 * Styles a list item activeBackground
		 */
		activeBackground: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		classes() {
			return {
				'InlineList-active': this.active,
				'InlineList--activeBackground': this.activeBackground,
			};
		},
	},
};
</script>

<style lang="scss"></style>
